module.exports = __webpack_public_path__ + "static/media/Group 680.e2bd6648.svg";